<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="confirmar"
    >
      <header class="m-the-modal-header">
        <h5>
          {{ titulo }}
        </h5>
        <AtomButtonTheModalCloseIcon/>
      </header>

      <!--
        El backend rechazo la operacion. Se muestra SU mensaje, que explica exactamente que paso
        —"el producto quedaria sin proyectos y sin Droops", "tiene planes de contado o de cuotas"—
        en vez de la alerta generica de "no se pudo actualizar", que no decia nada y dejaba al
        usuario sin saber que corregir.
      -->
      <template v-if="motivo">
        <section
          key="modalSectionFailed"
          class="m-the-modal-section-height-auto m-satellites-modal"
        >
          <p class="m-satellites-modal-intro">
            {{ $t('mEditionProductSatellitesIncluded.modal.failed.intro') }}
          </p>

          <p class="m-satellites-modal-note m-satellites-modal-note-warning">
            <i class="fas fa-exclamation-circle"></i>
            <span>{{ motivo }}</span>
          </p>
        </section>

        <footer class="m-the-modal-footer">
          <AtomButtonTheModalCancelAction
            :cancel-text="$t('mEditionProductSatellitesIncluded.modal.failed.buttonClose')"
          />
        </footer>
      </template>

      <!--
        Modo bloqueado: el producto tiene planes que este tipo no admite (para un Droop, de contado o
        cuotas), asi que todavia no puede incluirlo. No es una confirmacion sino una explicacion, por
        eso no hay boton de guardar: se dice el porque, se nombran los planes que hay que dar de baja
        y se cierra. Los textos van por tipo porque cada satelite tiene su propia regla de cobro.
      -->
      <template v-else-if="bloqueado">
        <section
          key="modalSectionBlocked"
          class="m-the-modal-section-height-auto m-satellites-modal"
        >
          <p class="m-satellites-modal-intro">
            {{ $t(`mEditionProductSatellitesIncluded.modal.blocked.${tipo}.intro`) }}
          </p>

          <p class="m-satellites-modal-note m-satellites-modal-note-warning">
            <i class="fas fa-exclamation-circle"></i>
            <span>{{ $t(`mEditionProductSatellitesIncluded.modal.blocked.${tipo}.reason`) }}</span>
          </p>

          <ul class="m-satellites-modal-limits">
            <li
              v-for="plan in planesIncompatibles"
              :key="plan.id"
            >
              <span>{{ plan.divisa }}</span>
              <b>{{ plan.nombre }}</b>
            </li>
          </ul>

          <p class="m-satellites-modal-note">
            <i class="fas fa-info-circle"></i>
            <span>{{ $t(`mEditionProductSatellitesIncluded.modal.blocked.${tipo}.howTo`) }}</span>
          </p>
        </section>

        <footer class="m-the-modal-footer">
          <AtomButtonTheModalCancelAction
            :cancel-text="$t('mEditionProductSatellitesIncluded.modal.blocked.buttonClose')"
          />
        </footer>
      </template>

      <template v-else>

      <!-- height-auto en vez de la seccion normal: esa tiene max-height 280px y saca scroll -->
      <section
        key="modalSection"
        class="m-the-modal-section-height-auto m-satellites-modal"
      >
        <p class="m-satellites-modal-intro">
          {{ action === 'add'
            ? $t('mEditionProductSatellitesIncluded.modal.textAdd')
            : $t('mEditionProductSatellitesIncluded.modal.textRemove') }}
          <b>{{ satelite.titulo }}</b>
        </p>

        <p
          v-if="satelite.descripcion"
          class="m-satellites-modal-description"
        >
          {{ satelite.descripcion }}
        </p>

        <h6 class="m-satellites-modal-subtitle">
          {{ $t('mEditionProductSatellitesIncluded.modal.caracteristicas') }}
        </h6>

        <!-- Dos columnas: con 6 limites entra sin estirar el modal -->
        <ul class="m-satellites-modal-limits">
          <li
            v-for="limite in limites"
            :key="limite.key"
          >
            <span>{{ limite.label }}</span>
            <b>{{ limite.value }}</b>
          </li>
        </ul>

        <p
          v-if="mostrarReemplazo"
          class="m-satellites-modal-note m-satellites-modal-note-warning"
        >
          <i class="fas fa-exclamation-circle"></i>
          <span>{{ textoReemplazo }}</span>
        </p>

        <p
          v-if="action === 'add' && textoCobro"
          class="m-satellites-modal-note"
        >
          <i class="fas fa-info-circle"></i>
          <span>{{ textoCobro }}</span>
        </p>

        <p class="m-satellites-modal-note">
          <i class="fas fa-info-circle"></i>
          <span>{{ $t('mEditionProductSatellitesIncluded.modal.salesWarning') }}</span>
        </p>
      </section>

      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction
          :cancel-text="$t('mEditionProductSatellitesIncluded.modal.buttons.cancel')"
        />
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
      </template>
    </form>
  </div>
</template>

<script>
/*
 | Lo que muestra el modal de cada tipo de satelite, en ese orden, con la clave con la que viene en
 | el listado. Las etiquetas estan en limites.<tipo> de m-edition-product-satellites-included.js.
 |
 | Es un mapa y no un ternario "juedroop o evaluacion": con un tipo nuevo, el ternario le mostraria
 | los limites de otro (que no vienen, asi que la lista saldria vacia sin avisar).
 */
const LIMITES = {
  juedroop: ['maximo_juegos', 'maximo_preguntas_por_juego', 'maximo_jugadores_por_sala',
    'maximo_jugadores_por_sala_en_vivo', 'modo_individual', 'modo_en_vivo'],
  evaluacion: ['maximo_evaluaciones', 'maximo_preguntas_por_evaluacion', 'modo_examen', 'modo_practica',
    'modo_autoevaluacion', 'resultados_analitica', 'exportacion_csv'],
  ruleta: ['maximo_ruletas', 'maximo_segmentos_por_ruleta', 'modo_premios', 'modo_preguntas',
    'enlace_publico', 'exportacion_csv'],
  ia_mensual: ['creditos'],
  ia_creditos: ['creditos']
}

export default {
  name: 'MoleculeEditionProductSatellitesIncludedModal',

  data () {
    return {
      action: 'add',

      // Tiene que ser data y no computed: AtomButtonPrimary muta el objeto en su created()
      // (le pone behavior y pasa action a minusculas) y ademas necesitamos setear sending
      buttonPrimary: {
        action: '',
        behavior: 'save',
        class: '',
        sending: false,
        type: 'submit'
      },

      // El veredicto de satelites/validacion, ya tomado por el backend, y los planes que lo
      // sostienen. El modal no lo re-deduce: lo muestra.
      bloqueado: false,
      // Mensaje con el que el backend rechazo la operacion. Con esto puesto, el modal no confirma
      // nada: solo explica que paso.
      motivo: '',
      planesIncompatibles: [],

      satelite: {},
      sateliteIncluido: null,
      tipo: 'juedroop'
    }
  },

  computed: {
    titulo () {
      if (this.motivo) {
        return this.action === 'add'
          ? this.$t('mEditionProductSatellitesIncluded.modal.failed.titleAdd')
          : this.$t('mEditionProductSatellitesIncluded.modal.failed.titleRemove')
      }

      if (this.bloqueado) {
        return this.$t('mEditionProductSatellitesIncluded.modal.blocked.title')
      }

      return this.action === 'add'
        ? this.$t('mEditionProductSatellitesIncluded.modal.titleAdd')
        : this.$t('mEditionProductSatellitesIncluded.modal.titleRemove')
    },

    limites () {
      return (LIMITES[this.tipo] || [])
        .filter(clave => this.satelite[clave] !== undefined && this.satelite[clave] !== null)
        .map(clave => ({
          key: clave,
          label: this.$t(`mEditionProductSatellitesIncluded.limites.${this.tipo}.${this.camelize(clave)}`),
          value: this.valorDelLimite(clave, this.satelite[clave])
        }))
    },

    // Como se cobra el tipo, para los que tienen texto en modal.cobro (los de IA)
    textoCobro () {
      const clave = `mEditionProductSatellitesIncluded.modal.cobro.${this.tipo}`

      return this.$te(clave) ? this.$t(clave) : ''
    },

    // Solo se avisa del reemplazo cuando de verdad va a reemplazar a otro distinto
    mostrarReemplazo () {
      return this.action === 'add' &&
        !!this.sateliteIncluido &&
        this.sateliteIncluido.id !== this.satelite.id
    },

    textoReemplazo () {
      return this.$t('mEditionProductSatellitesIncluded.modal.replaceWarning')
        .replace('{satelite}', this.sateliteIncluido ? this.sateliteIncluido.titulo : '')
    }
  },

  created () {
    this.action = this.$modal.element.action
    this.satelite = this.$modal.element.satelite
    this.sateliteIncluido = this.$modal.element.sateliteIncluido
    this.tipo = this.$modal.element.tipo
    this.bloqueado = !!this.$modal.element.bloqueado
    this.motivo = this.$modal.element.motivo || ''
    this.planesIncompatibles = this.$modal.element.planesIncompatibles || []

    if (this.action === 'add') {
      this.buttonPrimary.action = this.$t('mEditionProductSatellitesIncluded.modal.buttons.confirmAdd')
      this.buttonPrimary.behavior = 'save'
      this.buttonPrimary.class = 'a-button-products-primary'
    } else {
      this.buttonPrimary.action = this.$t('mEditionProductSatellitesIncluded.modal.buttons.confirmRemove')
      this.buttonPrimary.behavior = 'delete'
      this.buttonPrimary.class = 'a-button-danger-primary'
    }
  },

  methods: {
    camelize (text) {
      return text.replace(/_([a-z])/g, (match, letra) => letra.toUpperCase())
    },

    /*
     | Los creditos se muestran siempre con su numero real y separador de miles ("5.000"): nunca pasan
     | por "Ilimitado" ni por el tope de los Droops, que para creditos no existe.
     */
    valorDelLimite (clave, valor) {
      if (typeof valor === 'boolean') {
        return valor ? 'Sí' : 'No'
      }

      if (clave === 'creditos') {
        return Number(valor).toLocaleString('es-AR')
      }

      return valor
    },

    confirmar () {
      // En modo bloqueado no hay boton de guardar, pero el form sigue siendo un form: un Enter en
      // el modal dispararia el submit igual
      if (this.motivo || this.bloqueado || this.buttonPrimary.sending) {
        return
      }

      // No se cierra el modal aca: closeModal() de app-academy pone element = null y el listado lee
      // ese element en su watcher, que corre recien en el proximo tick. Cierra el listado cuando
      // termina el request, igual que "Formaciones Incluidas".
      this.buttonPrimary.sending = true
      this.$modal.updateData('updateProductoSatelites')
    }
  }
}
</script>
